var _circle, _path, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3077,
    cy: 24.6154,
    r: 21.3077,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3081 15.3848V25.3848L33.0774 32.6925",
    stroke: "#AB9834",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.8467,
    y1: 6.1543,
    x2: 32.8467,
    y2: 0.000438734,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32.8467,
    y1: 50,
    x2: 32.8467,
    y2: 43.8461,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.3081,
    y1: 6.1543,
    x2: 11.3081,
    y2: 0.000438734,
    stroke: "#AB9834",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.3081,
    y1: 50,
    x2: 11.3081,
    y2: 43.8461,
    stroke: "#AB9834",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTime);
export default __webpack_public_path__ + "static/media/footer-time.d22281c388c574d4ce60b36a6da1bc96.svg";
export { ForwardRef as ReactComponent };